import React from "react";
import SettingsSection from "../SettingsSection";
import ChannelPicker from "../ChannelPicker";
import RolePicker from "../RolePicker";

export default function StaffQuotaSection({
  channels,
  roles,
  staffQuota,
  setStaffQuota,
}) {
  const update = (field, value) => {
    setStaffQuota({ ...staffQuota, [field]: value });
  };

  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Configure message and voice goals for staff roles. Staff meet the quota
        by reaching <strong>either</strong> the message goal <strong>or</strong>{" "}
        the voice goal (set a goal to 0 to ignore that track). Staff can check
        progress with <code>/quota</code>; admins can overview or reset with{" "}
        <code>/quotas</code>.
      </p>

      <div className="toggle-group" style={{ marginBottom: "20px" }}>
        <label className="input-label" style={{ marginBottom: 0 }}>
          ENABLE STAFF QUOTAS
        </label>
        <button
          type="button"
          className="manage-btn"
          style={{ width: "120px", margin: 0 }}
          onClick={() => update("enabled", !staffQuota.enabled)}
        >
          {staffQuota.enabled ? "ENABLED" : "DISABLED"}
        </button>
      </div>

      <label className="input-label">STAFF ROLES (COUNTED)</label>
      <RolePicker
        roles={roles}
        value={staffQuota.staffRoleIds || []}
        onChange={(ids) => update("staffRoleIds", ids)}
        multiple
        placeholder="Select staff roles…"
      />
      <p
        className="help-text"
        style={{ fontSize: "0.75rem", marginTop: "8px", opacity: 0.6 }}
      >
        Selected: {(staffQuota.staffRoleIds || []).length} role(s)
      </p>

      <label className="input-label" style={{ marginTop: "15px" }}>
        MESSAGE GOAL (PER PERIOD)
      </label>
      <input
        type="number"
        min="0"
        value={staffQuota.messageGoal ?? 50}
        onChange={(e) => update("messageGoal", Number(e.target.value) || 0)}
        className="settings-input"
      />

      <label className="input-label">VOICE MINUTES GOAL (PER PERIOD)</label>
      <input
        type="number"
        min="0"
        value={staffQuota.voiceMinutesGoal ?? 60}
        onChange={(e) =>
          update("voiceMinutesGoal", Number(e.target.value) || 0)
        }
        className="settings-input"
      />

      <label className="input-label">PERIOD LENGTH (DAYS)</label>
      <input
        type="number"
        min="1"
        max="90"
        value={staffQuota.periodDays ?? 7}
        onChange={(e) =>
          update("periodDays", Math.max(1, Number(e.target.value) || 7))
        }
        className="settings-input"
      />

      <label className="input-label">MIN MESSAGE LENGTH</label>
      <input
        type="number"
        min="1"
        max="100"
        value={staffQuota.minMessageLength ?? 1}
        onChange={(e) =>
          update("minMessageLength", Math.max(0, Number(e.target.value) || 0))
        }
        className="settings-input"
      />
      <p
        className="help-text"
        style={{ fontSize: "0.75rem", marginTop: "-8px", opacity: 0.6 }}
      >
        Set to 0 to count every message (including short replies). Images and
        stickers always count.
      </p>

      <label className="input-label" style={{ marginTop: "15px" }}>
        REPORT CHANNEL (OPTIONAL)
      </label>
      <ChannelPicker
        channels={channels}
        value={staffQuota.reportChannelId || ""}
        onChange={(v) => update("reportChannelId", v)}
        types={[0]}
        emptyLabel="None"
      />
      <p
        className="help-text"
        style={{ fontSize: "0.75rem", marginTop: "-8px", opacity: 0.6 }}
      >
        When a period ends, a summary of who met / missed quota is posted here.
      </p>

      <div className="toggle-group" style={{ marginTop: "10px" }}>
        <label className="input-label" style={{ marginBottom: 0 }}>
          IGNORE AFK VOICE CHANNEL
        </label>
        <button
          type="button"
          className="manage-btn"
          style={{ width: "120px", margin: 0 }}
          onClick={() => update("ignoreAfk", !staffQuota.ignoreAfk)}
        >
          {staffQuota.ignoreAfk !== false ? "YES" : "NO"}
        </button>
      </div>
    </SettingsSection>
  );
}
